import { useState } from "react";
import { useNavigate } from "react-router-dom";

import UserForm from "../components/UserForm";

import { useUsers } from "../hooks/useUsers";

const CreateUserPage = () => {
  const navigate = useNavigate();

  const { createUser } = useUsers();

  const [loading, setLoading] =
    useState(false);

  const [serverError, setServerError] =
    useState("");

  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      setServerError("");

      await createUser(data);

      navigate("/users");
    } catch (error) {
      setServerError(
        error?.response?.data?.message ||
          "Unable to create user."
      );

      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl space-y-6">
      {/* Header */}
      <div>
        <button
          type="button"
          onClick={() => navigate("/users")}
          className="mb-3 text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          ← Back to users
        </button>

        <h1 className="text-2xl font-bold text-slate-900">
          Create user
        </h1>

        <p className="mt-1 text-sm text-slate-500">
          Create a new Sales or Agent account.
        </p>
      </div>

      {/* Form */}
      <div className="rounded-xl border border-slate-200 bg-white p-6 sm:p-8">
        <UserForm
          mode="create"
          onSubmit={handleSubmit}
          onCancel={() =>
            navigate("/users")
          }
          loading={loading}
          serverError={serverError}
        />
      </div>
    </div>
  );
};

export default CreateUserPage;